import { Component, Input } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'sentry-readonly-field',
    templateUrl: './readonly-field.component.html',
    styleUrls: ['./readonly-field.component.scss'],
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatIconModule]
})
export class ReadonlyFieldComponent {
  @Input() label!: string;
  @Input() value: string | string[] | boolean | number | undefined | null;
  @Input() route: UrlTree | null = null;
  @Input() isSecret = false;

  isVisible = false;

  constructor(private readonly router: Router) {}

  navigate() {
    if (!this.route) {
      throw new Error('No route found');
    }

    this.router.navigateByUrl(this.route);
  }
}
